import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import moment from "moment-jalaali";
import { useTranslation } from "react-i18next";
import { get } from "../../../controlers/global/ConfigRequest";
import { USER_COIN_HISTORY } from "../../../helperData/ApiAddress";

const COIN_TYPE_KEYS = {
    1: "UserPanel.Points.Type.Feedback",
    2: "UserPanel.Points.Type.Discount",
    3: "UserPanel.Points.Type.Content",
    4: "UserPanel.Points.Type.Restaurant",
};

export default function PointsHistory() {
    const { t } = useTranslation();
    const [rows, setRows] = useState(undefined);

    useEffect(() => {
        get(USER_COIN_HISTORY)
            .then((r) => setRows(Array.isArray(r) ? r : r?.results || []))
            .catch(() => setRows([]));
    }, []);

    if (rows === undefined) {
        return (
            <div className="user-panel-empty">
                <Spinner animation="border" />
            </div>
        );
    }

    if (!rows.length) {
        return (
            <div className="user-panel-empty">
                {t("UserPanel.Points.Empty")}
            </div>
        );
    }

    return (
        <div className="points-history-table">
            <div className="points-history-table__head">
                <div>{t("UserPanel.dashboard.PointsShowcase.Date&Time.Label")}</div>
                <div>{t("UserPanel.dashboard.PointsShowcase.Factor.Label")}</div>
                <div>{t("UserPanel.dashboard.PointsShowcase.Case.Label")}</div>
                <div>{t("UserPanel.dashboard.PointsShowcase.PointsAmount.Label")}</div>
            </div>
            {rows.map((row) => {
                const isEarn = Number(row.transaction_type) === 1;
                return (
                    <div className="points-history-table__row" key={row.id}>
                        <div>
                            {row.created_at
                                ? moment(row.created_at).format("jYYYY/jMM/jDD HH:mm")
                                : "-"}
                        </div>
                        <div>
                            {t(COIN_TYPE_KEYS[row.coin_type] || COIN_TYPE_KEYS[1])}
                        </div>
                        <div>
                            {isEarn
                                ? t("UserPanel.dashboard.PointsShowcase.Case.Entry.Label")
                                : t("UserPanel.dashboard.PointsShowcase.Case.Output.Label")}
                        </div>
                        <div className={isEarn ? "earn" : "spend"}>
                            {isEarn ? "+" : "-"}
                            {Math.abs(row.number_of_coin || 0)}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
